import React from "react";
import PropTypes from "prop-types";
import { Card, Grid } from "@mui/material";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import FormInforme from "../Form/FormInforme";

const HeaderInforme = ({ children, onCreateCycle }) => {
  // Esta función ahora se pasa directamente al formulario
  // No necesita hacer nada más

  return (
    <MDBox position="relative" sx={{ mt: -4, mx: -3, py: 2, px: -2 }}>
      <Card sx={{ mt: 1, mx: 3, py: 2, px: 2 }}>
        <Grid container alignItems="center" justifyContent="space-between" spacing={3}></Grid>

        {/* Separador y título del formulario */}
        <MDBox mt={3} mb={2}></MDBox>

        {/* Formulario integrado - pasa la función onCreateCycle */}
        <FormInforme
          onSubmit={onCreateCycle}
          showSuccessMessage={false} // Dejamos que el componente padre maneje los mensajes
        />

        {/* Espacio para contenido adicional */}
        {children && <MDBox mt={4}>{children}</MDBox>}
      </Card>
    </MDBox>
  );
};

HeaderInforme.defaultProps = {
  children: null,
  onCreateCycle: null,
};

HeaderInforme.propTypes = {
  children: PropTypes.node,
  onCreateCycle: PropTypes.func,
};

export default HeaderInforme;
